import Vue from 'vue';
import '@dsee/init.js';
import './3k.scss';
import './styles.base.scss';

Vue.config.devtools = true;

import VueRouter from 'vue-router';
Vue.use(VueRouter);


import VueModal from './util/vue.modal.js';
Vue.use(VueModal);

import wysiwyg from './comp/wysiwyg';
Vue.use(wysiwyg, {
    hideModules: {
        table: true,
        headings: true,
        code: true,
    },
    forcePlainTextOnPaste: false,
});

import Vue2TouchEvents from 'vue2-touch-events';
Vue.use(Vue2TouchEvents);

/*******************************************************************************
 * Общие фильтры
 */

import joinMapping from '@dsee/components/filters/joinMapping.js';
Vue.filter('joinMapping', joinMapping);

import { textDefault } from '@/common/util/filters/textDefault.js';
Vue.filter('textDefault', textDefault);

import { joinAndMap } from '@/common/util/filters/joinAndMap.js';
Vue.filter('joinAndMap', joinAndMap);

/*******************************************************************************
 * Общие миксины
 */


/*******************************************************************************
 * Общие компоненты
 */
import AttachmentInfo from './comp/attachment/AttachmentInfo.vue';


Vue.component('AttachmentInfo', AttachmentInfo);

import BottomSheet from '@/common/comp/bottom_sheet/BottomSheet.vue';
Vue.component('BottomSheet', BottomSheet);

import MobileInlineMultiSelect from './comp/selects/mobile/Multiselect.vue';
Vue.component('MobileInlineMultiSelect', MobileInlineMultiSelect);

import MobileInlineSelect from './comp/selects/mobile/Select.vue';
Vue.component('MobileInlineSelect', MobileInlineSelect);

import MobileInlineDatePicker from './comp/picker/datepicker/mobile/InlineDatePicker.vue';

Vue.component('MobileInlineDatePicker', MobileInlineDatePicker);

import InputUrl from './comp/input_url/InputUrl.vue';
Vue.component('InputUrl', InputUrl);


import SideNav from '@/common/comp/sidenav/SideNav.vue';
Vue.component('SideNav', SideNav);

import TooltipOld from '@/common/comp/tooltip/TooltipOld.vue';
Vue.component('TooltipOld', TooltipOld);

import Overflow from '@dsee/components/overflow/Overflow.vue';
import OverflowMixin from '@/common/comp/overflow/overflow.mixin.js';
Vue.component('Overflow', {
    extends: Overflow,
    mixins: [ OverflowMixin ],
});

import Navigator from '@dsee/components/navigator/Navigator.vue';
import NavigatorMixin from '@/common/comp/navigator/navigator.mixin.js';


Vue.component('Navigator', {
    extends: Navigator,
    mixins: [ NavigatorMixin ],
});

import BackButton from '@/common/comp/back_button/BackButton.vue';
Vue.component('BackButton', BackButton);

import ErrorMessageTooltip from '@/common/comp/error_message/ErrorMessageTooltip.vue';
Vue.component('ErrorMessageTooltip', ErrorMessageTooltip);

import DropdownIconed from '@/common/comp/dropdown_iconed/DropdownIconed.vue';
Vue.component('DropdownIconed', DropdownIconed);


import DropArea from '@/common/comp/drop_file/DropArea.vue';


Vue.component('DropArea', DropArea);

/*******************************************************************************
 * Общие иконки
 */
import IconLink from './icons/link.svg?component';

Vue.component('IconLink', IconLink);

import IconLink2 from './icons/link2.svg?component';

Vue.component('IconLink2', IconLink2);

import IconPlusLarge from './icons/plus_large.svg?component';

Vue.component('IconPlusLarge', IconPlusLarge);

import IconClose from './icons/close.svg?component';

Vue.component('IconClose', IconClose);

import IconSearch from './icons/search.svg?component';
Vue.component('IconSearch', IconSearch);

import IconEyeLarge from './icons/eye_large.svg?component';
Vue.component('IconEyeLarge', IconEyeLarge);

import IconChevronUp from './icons/chevron_up.svg?component';
Vue.component('IconChevronUp', IconChevronUp);

import IconChevronDown from './icons/chevron_down.svg?component';
Vue.component('IconChevronDown', IconChevronDown);

import IconChevronDownLarge from './icons/chevron_down_large.svg?component';
Vue.component('IconChevronDownLarge', IconChevronDownLarge);

import IconCloseSmall from './icons/close_small.svg?component';
Vue.component('IconCloseSmall', IconCloseSmall);

import IconFilterClear from './icons/filter_clear.svg?component';
Vue.component('IconFilterClear', IconFilterClear);

import IconTrashSmall from './icons/trash_small.svg?component';
Vue.component('IconTrashSmall', IconTrashSmall);

import IconTrashLarge from './icons/trash_large.svg?component';
Vue.component('IconTrashLarge', IconTrashLarge);

import IconEditSmall from './icons/edit_small.svg?component';
Vue.component('IconEditSmall', IconEditSmall);

import IconEditLarge from './icons/edit_large.svg?component';
Vue.component('IconEditLarge', IconEditLarge);

import IconArrowLeft from './icons/arrow_left.svg?component';
Vue.component('IconArrowLeft', IconArrowLeft);

import IconSubscribe from './icons/subscribe.svg?component';
Vue.component('IconSubscribe', IconSubscribe);

import ChevronRight from './icons/chevron_right.svg?component';
Vue.component('ChevronRight', ChevronRight);

import IconPlusSmall from './icons/plus_small.svg?component';
Vue.component('IconPlusSmall', IconPlusSmall);

import IconHistory from './icons/history.svg?component';
Vue.component('IconHistory', IconHistory);

import IconArrowDown from './icons/arrow_down.svg?component';
Vue.component('IconArrowDown', IconArrowDown);

import IconCheckMini from './icons/check_mini.svg?component';
Vue.component('IconCheckMini', IconCheckMini);

import IconCloseMini from './icons/close_mini.svg?component';
Vue.component('IconCloseMini', IconCloseMini);

import IconLogout from './icons/menu/logout.svg?component';
Vue.component('IconLogout', IconLogout);

import IconChevronDownMedium from './icons/chevron_down_medium.svg?component';
Vue.component('IconChevronDownMedium', IconChevronDownMedium);

import IconInform from './icons/inform.svg?component';
Vue.component('IconInform', IconInform);
